import $ from "jquery";

export const Leaderboard = () => {
    if ($(".leaderboard").length < 1) {
        return;
    }

    const $elms = {
        transitionPage: $(".transitionPage"),
        filter: $("#leaderboard-filter"),
        backBtn: $(".app__back"),
    };

    function init() {
        $elms.transitionPage.removeClass("is-active");
        registerEvents();
    }

    function registerEvents() {
        $elms.filter.on("change", onChangeFilter);
        $elms.backBtn.on("click", onClickBackBtn);
    }

    function onChangeFilter() {
        const $this = $(this);

        const day = $this.val();
        location.href = `/leaderboard/?day=${day}`;
    }

    function onClickBackBtn() {
        location.href = "/result";
    }

    init();
};
